import { z } from 'zod';

export const paginatedResponse = z.object({
  pageIndex: z.number(),
  pageSize: z.number(),
  total: z.number(),
});

/**
 * Helper type to add pagination properties to the response
 */
export type PaginatedResponse<Data> = z.infer<typeof paginatedResponse> & Data;
